const buildViewLoginPosterEvent = (inputProperties) => {
    return {
        ...inputProperties,
        object: {
            ...inputProperties.object,
            type: 'LoginPoster',
        },
    };
};
export { buildViewLoginPosterEvent };
//# sourceMappingURL=event-builder.js.map